/** Page-session drafts only. Never presented as a server-persisted student record. */
export interface FoxKifuReflectionState {
  readonly openRecordId: string | null;
  readonly drafts: ReadonlyMap<string, string>;
}

export type FoxKifuReflectionAction =
  | { readonly type: 'open'; readonly recordId: string }
  | { readonly type: 'close' }
  | { readonly type: 'edit'; readonly recordId: string; readonly html: string };

export function createFoxKifuReflectionState(): FoxKifuReflectionState {
  return { openRecordId: null, drafts: new Map() };
}

export function foxKifuReflectionReducer(
  state: FoxKifuReflectionState,
  action: FoxKifuReflectionAction,
): FoxKifuReflectionState {
  if (action.type === 'open') return { ...state, openRecordId: action.recordId };
  if (action.type === 'close') return { ...state, openRecordId: null };
  // Ignore any late editor event from a previously mounted record.
  if (action.recordId !== state.openRecordId) return state;
  const drafts = new Map(state.drafts);
  drafts.set(action.recordId, action.html);
  return { ...state, drafts };
}

export const FOX_REFLECTION_MAX_LENGTH = 8_000;
